import { BackburgerIcon } from './BackburgerIcon';

/**
 * author: Austin Andrews
 * id 5A5BC824-220B-4998-883A-0E57FB2AB75F
 * name backburger
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/backburger.svg
 * tags
 */
export const HamburgerMenuBackIcon = BackburgerIcon;
export default HamburgerMenuBackIcon